import React from 'react';

const Logo = ({ className = '', heightClass = 'h-8' }) => (
  <img
    src={`${process.env.PUBLIC_URL}/logo-trimmed.png`}
    alt="Lokyis"
    className={`block ${heightClass} w-auto object-contain ${className}`}
  />
);

export default Logo;
